export enum Constant {
    GenerateImagesColumn = 4,
    CollectImagesColumn = 2,
    FrameVerticalGap= 600,

    FrameColumnGap = 20,
    FramePadding = 40,
    MaxImageWidth =  600
}
